import { render, staticRenderFns } from "./AppBarPages.vue?vue&type=template&id=e484c24c"
import script from "./AppBarPages.vue?vue&type=script&lang=js"
export * from "./AppBarPages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports